import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import ReactApexChart from "react-apexcharts";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { GetAllNoHideSubsnameList } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { ISeries } from "../PayBoard/PayHistorySection";
import {
  AxixTitle,
  ChartContainer,
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import useIsMobile from "../../../../hooks/useIsMobile";
import { GetAllNoHideSubsnameListv3 } from "../../../../ApiTS/ServiceDatasTS_V3";

interface CreateSectionProps extends IndateSectionProps {}

export default function CreateSection({
  filter,
  setFilter,
}: CreateSectionProps) {
  const isMobile = useIsMobile();

  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType>({
    value: "0",
    label: "전체",
  });

  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [date, setDate] = useState<string[]>([]);

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=party&subtype=create&startdate=${dayjs(
            filter.startDate
          )
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&filter=day` +
          (subsDropdownValue?.value === "0"
            ? ""
            : `&detail=${subsDropdownValue.value}`)
        : undefined,
  });

  // subscription 선택 옵션
  const subsOptionList = isMobile ? [] : [{ value: "0", label: "전체" }];

  const subsNameList = GetAllNoHideSubsnameListv3();

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({ value: e?.split("_")[0], label: e });
  }

  useEffect(() => {
    let date: string[] = [];
    let createCount: number[] = [];

    if (response?.status === 200) {
      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        createCount.push(Number(element?.data?.count ?? 0));
        date.push(dayjs(element?.date).add(-1, "day").format("M/D (dd)"));
      }

      setSeries([
        {
          name: "create",
          data: createCount.reverse(),
        },
      ]);
      setDate(date.reverse());
    }
  }, [response, subsDropdownValue]);

  console.log(subsDropdownValue);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>신규 파티 생성 현황</DashBoardSectionTitle>

        <DropDown
          isDisabled={false}
          initText="전체"
          setDropDownValue={setSubsDropdownValue}
          optionList={subsOptionList}
          dropdownValue={subsDropdownValue}
          initValue={"0"}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DropDownLabel>{`${
          subsDropdownValue.label?.split("_")[1] ?? subsDropdownValue.label
        }`}</DropDownLabel>
        <DashBoardViewDate isMobile={isMobile}>
          조회 기간 : {filter.startDate} ~ {filter.endDate}
        </DashBoardViewDate>

        <ChartContainer>
          <AxixTitle>명</AxixTitle>

          <ReactApexChart
            type="line"
            height={300}
            series={series}
            options={{
              chart: {
                height: 350,
                type: "line",
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: true,
                offsetY: -5,
                style: {
                  fontWeight: 500,
                  colors: ["#ffffff"],
                },
                formatter: (val) => {
                  return getThousandComma(val);
                },
                background: {
                  dropShadow: {
                    enabled: false,
                  },
                  borderColor: "#ffffff",
                  foreColor: "#22222",
                  padding: 0,
                },
              },
              stroke: {
                curve: "smooth",
              },
              xaxis: {
                categories: date,
              },
              yaxis: {
                labels: {
                  formatter: (value) => {
                    return getThousandComma(value ?? 0);
                  },
                },
              },
              tooltip: {
                y: {
                  formatter: (value) => getThousandComma(value ?? 0) + "명",
                },
              },
            }}
          />

          <AxixTitle isX={true}>날짜</AxixTitle>
        </ChartContainer>
      </LineBox>
    </>
  );
}

export const DropDownLabel = styled.div`
  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
`;
